module.exports = __webpack_public_path__ + "img/15-WHEEL.7b3d4cd0.png";